
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { Row, Col, Container, Button } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ApiService from 'services';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getIdFromSlug } from 'utils/misc';
const teamMenuOptions = [
    {
        "title": "Home",
        "link": "home"
    },
    {
        "title": "Players",
        "link": "players"
    },
    {
        "title": "Results",
        "link": "results"
    },
    {
        "title": "Schedule",
        "link": "schedule"
    },
    {
        "title": "Top Performers",
        "link": "top"
    },
    {
        "title": "Umpiring",
        "link": "umpiring"
    }
];


export default function TeamDetails(props) {

    const { teamSlug } = useParams();
    const [teamId, setTeamId] = useState("");
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('home');
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    useEffect(() => {
        setTeamId(getIdFromSlug(teamSlug));
    }, [teamSlug]);
    const handleCloseOffcanvas = () => {
        setShowOffcanvas(false);
        // Additional logic for when offcanvas is closed
        console.log('Offcanvas closed');
    };
    const getTeamMenu = () => {
        return <Tabs
            defaultActiveKey="home"
            id="uncontrolled-tab-example"
            className="mt-3"
            fill
            onSelect={handleTabSelect}
        >
            {teamMenuOptions.map((oneOption, index) => {
                return <Tab eventKey={oneOption.link} key={index} title={oneOption.title}>
                    <div className='vh-100'>
                        Tab content for {oneOption.title}
                    </div>
                </Tab>
            })}

        </Tabs>
    }
    const getTeamMenuMobile = (teamName) => {

        return <Navbar collapseOnSelect expand="lg" expanded={showOffcanvas}>
            <Container>

                <Button
                    variant="secondary"
                    onClick={() => setShowOffcanvas(true)}
                    aria-controls="responsive-navbar-nav"
                >
                    Team Menu
                </Button>

                <Navbar.Offcanvas
                    id='responsive-navbar-nav'
                    aria-labelledby='offcanvasNavbarLabel-expand-sm'
                    placement="end"
                    show={showOffcanvas} onHide={handleCloseOffcanvas}
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id='offcanvasNavbarLabel-expand-sm'>
                            {teamName}
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            style={{ maxHeight: '100px' }}
                        >
                            {teamMenuOptions.map((section, index) => (
                                section.hasChild ? <DropDownMenu key={index} linkTitle={section.title} childList={section.childList} /> : <Nav.Link key={index} href={section.url}>{section.title}</Nav.Link>
                            ))}
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    }
    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
        // Do something with the selected tab
        console.log('Selected Tab:', selectedTab);
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await ApiService.getTeamDetails(teamId);
                setData({ "TeamId": teamId, "TeamName": "Testing", "ShortName": "Testing", "Email": "", "Status": "1" });
                //console.log(response);
                setLoading(false);
            } catch (error) {
                // Handle error
                //
                console.log(error);
            }
        };
        fetchData();
    }, [teamId]);
    useEffect(() => {
        // Effect logic to run when activeTab changes
        console.log('Active Tab Changed:', activeTab);

        // Additional actions or API calls based on the activeTab can be performed here
        const fetchData = async () => {
            try {
                const response = await ApiService.getTeamDetails(teamId);
                setData({ "TeamId": teamId, "TeamName": "Testing", "ShortName": "Testing", "Email": "", "Status": "1" });
                //console.log(response);
                setLoading(false);
            } catch (error) {
                // Handle error
                //
                console.log(error);
            }
        };
        fetchData();
        // Cleanup function (if needed)
        return () => {
            // Cleanup logic here (if needed)
        };
    }, [activeTab]);
    if (loading) {
        return <div>Loading..</div>
    }
    else {
        return (
            <>
                <h1 className='text-center'> {!loading && data && data.TeamName}</h1>
                <Row>
                    <Col>
                        <div className='d-none d-md-block'>
                            {getTeamMenu()}
                        </div>
                        <div className='d-md-none'>
                            {getTeamMenuMobile(data.TeamName)}
                        </div>
                    </Col>
                </Row>

            </>
        )
    }
}